<template>
  <a-config-provider :prefixCls="antPrefix">
    <router-view />
  </a-config-provider>
</template>

<script>
import { debounce } from '@/utils/util'

export default {
  async mounted () {
    const handle = () => {
      const { innerWidth, outerWidth, innerHeight, outerHeight } = window
      this.$root.windowMode = {
        innerWidth,
        outerWidth,
        innerHeight,
        outerHeight
      }
      this.$forceUpdate()
    }
    window.addEventListener('resize', () => debounce(handle, 100))
    handle()
        this.$store.dispatch('downloadSocktConfig/initWS')
  }
}
</script>
